import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M17.401.75H6.598c-1.08 0-1.957.876-1.957 1.957v18.586c0 1.08.876 1.957 1.957 1.957h10.803c1.08 0 1.957-.876 1.957-1.957V2.707c0-1.08-.876-1.957-1.957-1.957"
    }, null, -1),
    createElementVNode("path", {
      stroke: "currentColor",
      d: "M8.459 8.695a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1m0-2.75a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1m3.5 3a.5.5 0 0 1 0-1m0 1a.5.5 0 0 0 0-1"
    }, null, -1)
  ]));
}
const computerDeviceMobilePhoneIphoneXBack = { render };
export {
  computerDeviceMobilePhoneIphoneXBack as default,
  render
};
//# sourceMappingURL=computer-device-mobile-phone-iphone-x-back.svg.js.map
